import { render, staticRenderFns } from "./DetailShare.vue?vue&type=template&id=08612b99&scoped=true&"
import script from "./DetailShare.vue?vue&type=script&lang=js&"
export * from "./DetailShare.vue?vue&type=script&lang=js&"
import style0 from "./DetailShare.vue?vue&type=style&index=0&id=08612b99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08612b99",
  null
  
)

export default component.exports